
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.75 4.5h3.75V6H15v9.75a.75.75 0 01-.75.75H3.75a.75.75 0 01-.75-.75V6H1.5V4.5h3.75V2.25A.75.75 0 016 1.5h6a.75.75 0 01.75.75V4.5zM13.5 6h-9v9h9V6zM6.75 8.25h1.5v4.5h-1.5v-4.5zm3 0h1.5v4.5h-1.5v-4.5zM6.75 3v1.5h4.5V3h-4.5z","fill":"#2B2B2B"}})])
          )
        }
      }
    